import React from 'react'
import {Link} from 'gatsby'
import projectStart from '../../assets/images/Start-project-with-us.png'
import shape from '../../assets/images/shape/circle-shape1.png'

const ProjectStartArea = () => {
    return (
        <div className="project-start-area ptb-100">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-12">
                        <div className="project-start-image">
                            <img src={projectStart} alt="project" />
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <div className="project-start-content">
                            <h3>Let's begin your project with us. </h3>
                            <p> We do all the work in taking your business to the next level</p>
                            
                            <Link to="/demo" className="default-btn">
                                <i className="flaticon-web"></i> 
                                Free Demo
                                <span></span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="circle-shape1">
                <img src={shape} alt="project" />
            </div>
        </div>
    )
}

export default ProjectStartArea;